/**
 * 个股行情电脑图标
 */
import React from 'react'
import './index.less'

export function HeaderComputer() {
  return (
    <a href={"//quote.eastmoney.com/zixuan/"} className="computer">
      <i className="header-computer"></i>
      <p className="computer-title">电脑版</p>
      <span className="split"></span>
    </a>
  )
}


export function StockHeaderComputer(props:{quoteCode:string}) {
  return (
    <a href={`http://quote.eastmoney.com/unify/r/${props.quoteCode}?jump_to_web=true`} className="computer">
      <i className="header-computer"></i>
      <p className="computer-title">电脑版</p>
    </a>
  )
}
